<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="أكرم-البرجس">
<h1><span dir="rtl">أكرم البرجس</span></h1>
<p style="text-indent:0em;"><span dir="rtl">أكرم البرجس، بدأ حياته في مدرسة القرية، ثمَّ أكملَ تعليمه الثانوي في ثانوية أبي العلاء المعري، تخرج في كلية التربية في إدلب بصفة مدرس.</span></p><br/>
<p style="text-indent:0em;"><span dir="rtl">عمل في مدارس</span> <span dir="rtl">المملكة العربية السعودية لمدة عشر سنوات، ليعود بعدها مع بدء الحراك الثوري، ويكون مِن أنصار الحراك السلمي ونبذ العنف والطائفيَّة.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2bbdff76